import React, { useState } from 'react'
import { Check } from 'react-feather';
import { ReactComponent as SEARCHICON } from "../../../assets/icons/search.svg";
import "./ClientsNameEmailfilter.css";

const ClientsNameEmailfilter = ({ setShowModal, clients, setSelectedClients, selectedClients ,isLast,isFirst }) => {
  const [filters, setFilters] = useState(selectedClients);
  const [searchClient, setSearchClient] = useState("");

  const handleCheck = (client) => {
    if (filters.find(f => f.name === client.name && f.email === client.email)) {
      setFilters(f => f.filter(f => !(f.name === client.name && f.email === client.email)));
    } else {
      setFilters(f => [...f, {name: client.name, email: client.email}]);
    }
  }

  const handleApply = (filters) => {
    setSelectedClients(filters)
    setShowModal("");
  }

  const handleClear = () => {
    setFilters([]);
    setSelectedClients([]);
    setShowModal("");
  }


  return <div className={`ClientDetailsFilterPopup md-w-full w-[420px] ${isLast ?"lg:left-0 md:right-0 right-[-2.4rem] " : ""} ${isFirst ? "lg:left-0 sm:left-0 left-[-17%]" : ""} `} onMouseLeave={() => setShowModal("")}>
    <div className="accountLanguageFilterSearch">
      <input
        className="accountLanguageFilterSearchInput"
        placeholder="Search by name, email"
        vlaue={searchClient}
        onChange={(e) => setSearchClient(e.target.value)}
      />
      <SEARCHICON className="accountLanguageFilterSearchIcon" />
    </div>

    <div className="accountDeatilsFilterItems accountDetailsBox">
        {clients.filter((el) => {
          return (el.name && (searchClient?.trim() ? el.name.toLowerCase().includes(searchClient.toLowerCase()) : true)) || (el.email && (searchClient?.trim() ? el.email.toLowerCase().includes(searchClient.toLowerCase()) : true))
        }).map((client, i) => <div key={client.id} className="hardCopyCheckboxLine">
          <div className={`${filters.find(f => f.name === client.name && f.email === client.email) ? "hardCopyChecked" : ""} hardCopyCheckbox`}>
            <Check className="hardCopyCheck" onClick={() => { handleCheck(client) }} style={{ opacity: filters.find(f => f.name === client.name && f.email === client.email) ? 1 : 0 }} />
          </div>
          <p className={`${filters.find(f => f.name === client.name && f.email === client.email) ? "" : "textNotSelected"} hardCopyCheckboxText`} onClick={() => { handleCheck(client) }}>{client.name}</p>
          <p className="hardCopyCheckboxText emailBox" onClick={() => { handleCheck(client) }}>{client.email}</p>
        </div>)}
    </div>


    <div className="accountDetailsFilterPopupBtns">
      <button className="accountOrderBtn accountClearBtn" onClick={() => { handleClear() }}>Clear</button>
      <button disabled={filters.length === 0} className="accountOrderBtn" onClick={() => { handleApply(filters) }}>Apply</button>
    </div>
  </div>
}

export default ClientsNameEmailfilter;